// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wloiy","title":"styles_title__sOn_S","membersIconsContainer":"styles_membersIconsContainer__x7h_f","logo":"styles_logo__WeEia"};